
export default [
    {
        path: '/cora-aplicacoes/:aplicacao?',
        name: 'aplicacao-cora',
        meta: {
            layout: 'full',
            title: 'Cora'
        },
        component: () => import (/* webpackPrefetch: 0 */ '@/views/pages/cora/CoraAplicacao/Cora.vue')
    },

    {
        path: '/cora/:chave?',
        name: 'cora',
        meta: {
            layout: 'full',
            title: 'Cora'
        },
        component: () => import ('@/views/pages/cora/Cora/Cora.vue')
    },

    {
        path: '/cora-lc/gad-7',
        name: 'cora-lc-gad-7',
        meta: {
            layout: 'full',
            title: 'Cora | GAD7'
        },
        component: () => import ('@/views/pages/cora/CoraLC/Cora.vue')
    },

    {
        path: '/cora-lc/phq-9',
        name: 'cora-lc-phq-9',
        meta: {
            layout: 'full',
            title: 'Cora | PHQ9'
        },
        component: () => import ('@/views/pages/cora/CoraLC/Cora.vue')
    },
]
